export default __webpack_public_path__ + "3cf51a79074745e095c5132d279b8dae.png";